import { makansafeConstants } from "@constants";
import { apiCaller } from "@utils";

// Report Users
export const actReportUsers = () => {
    const isLoading = true;
    return dispatch => {
        dispatch(request(isLoading));
        const params = {
            action_type: "report_users"
        };
        //Truyền true hàm apiCaller để sử dụng api makansafe
        return apiCaller(`/api/iddsi/functional/`, "POST", params, true).then(res => {
            const data = res && res.data;
            if (res && res.status === 200) {
                dispatch(success(data));
            } else {
                dispatch(failure("error"));
            }
        }).catch(error => {
            dispatch(failure(error.message || "error"));
        });
    };
    function request(isLoading) { return { type: makansafeConstants.REPORT_USERS_REQUEST, isLoading } }
    function success(data) { return { type: makansafeConstants.REPORT_USERS_SUCCESS, payload: data } }
    function failure(error) { return { type: makansafeConstants.REPORT_USERS_FAILURE, error: error } }
}

// Create IDDSI Account
export const actCreateIddsiAccount = (params) => {
    const isLoading = true;
    return dispatch => {
        dispatch(request(isLoading));
        const requestParams = {
            action_type: "create_iddsi_account",
            firstname: params.firstname,
            lastname: params.lastname,
            email: params.email,
            password: params.password,
            ward: params.ward || ""
        };
        //Truyền true hàm apiCaller để sử dụng api makansafe
        return apiCaller(`/api/iddsi/register/`, "POST", requestParams, true).then(res => {
            const data = res && res.data;
            if (res && res.status === 200) {
                dispatch(success(data));
            } else {
                dispatch(failure(res?.data?.error || "error"));
            }
        }).catch(error => {
            dispatch(failure(error.message || "error"));
        });
    };
    function request(isLoading) { return { type: makansafeConstants.CREATE_IDDSI_ACCOUNT_REQUEST, isLoading } }
    function success(data) { return { type: makansafeConstants.CREATE_IDDSI_ACCOUNT_SUCCESS, payload: data } }
    function failure(error) { return { type: makansafeConstants.CREATE_IDDSI_ACCOUNT_FAILURE, error: error } }
}

// Deactivate User Account
export const actDeactivateUserAccount = (email) => {
    const isLoading = true;
    return dispatch => {
        dispatch(request(isLoading));
        const formdata = new FormData();
        formdata.append("Email", email);
        
        //Truyền true hàm apiCaller để sử dụng api makansafe
        return apiCaller(`/api/auth/delete_account/`, "POST", formdata, true).then(res => {
            const data = res && res.data;
            if (res && res.status === 200) {
                dispatch(success(data));
                return res; // Return response for promise handling
            } else {
                dispatch(failure(res?.data?.error || "error"));
                return res; // Return response even on error
            }
        }).catch(error => {
            dispatch(failure(error.message || "error"));
            throw error; // Re-throw for promise handling
        });
    };
    function request(isLoading) { return { type: makansafeConstants.DEACTIVATE_USER_ACCOUNT_REQUEST, isLoading } }
    function success(data) { return { type: makansafeConstants.DEACTIVATE_USER_ACCOUNT_SUCCESS, payload: data } }
    function failure(error) { return { type: makansafeConstants.DEACTIVATE_USER_ACCOUNT_FAILURE, error: error } }
}

